import React from 'react';
import { motion } from 'framer-motion';

const Intro = () => {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="orb orb-3"></div>
      
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-3xl overflow-hidden relative">
              <div className="absolute inset-0 bg-cyan-900/20 mix-blend-overlay z-10"></div>
              <img 
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1000&auto=format&fit=crop" 
                alt="Digital Earth Data" 
                className="w-full h-full object-cover"
              />
              {/* High-tech overlay elements */}
              <div className="absolute top-0 left-0 w-full h-full border border-white/10 rounded-3xl z-20"></div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-purple-600/30 blur-3xl z-0"></div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-cyan-400 font-medium tracking-widest text-sm uppercase mb-4 block font-display">
              A Different Kind of Digital Partner
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-8 leading-tight">
              Your Marketing & Technology Should <span className="text-gradient">Work Together.</span>
            </h2>
            
            <div className="space-y-6 text-lg text-gray-400 leading-relaxed font-light">
              <p>
                Most businesses are forced to manage separate website developers, advertising agencies, SEO companies, social media teams, software providers, and technology consultants.
              </p>
              <div className="pl-6 border-l-2 border-cyan-500/50">
                <p className="text-gray-200 font-medium">
                  The result is usually fragmented communication, inconsistent strategy, duplicated work, and missed opportunities.
                </p>
              </div>
              <p>
                LAJ Digital brings everything together. We develop the strategy, build the technology, generate the traffic, improve the customer experience, and create the systems that help turn more opportunities into revenue.
              </p>
              <p className="text-xl font-display text-cyan-300 pt-4">
                From the first Google search to the first phone call—and everything that happens afterward—we help build a more connected path to growth.
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Intro;